import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { Trans } from "react-i18next";
import APIDefintions from "../../../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../../../yoello-lib/modules/API/API";
import { IReduxAppState } from "../../../../reducers";
import IMenuItemBody from "../../../../interfaces/IMenuItemBody";
import { FilterOptionsType } from "../../../../yoello-lib/modules/components/UI/Lists/AdvancedChecklist/state/AdvancedChecklist.actions";
import { ISearchableChecklistItem } from "../../../../yoello-lib/modules/components/UI/Lists/SearchableChecklist/SearchableChecklistItem";
import { useDialogRouteStages } from "../../../dialogRoutes/useDialogRouteStages";
import { useHistory } from "react-router-dom";
import { ADD_ITEM, dialogKeys, PRODUCTS_EXTRAS } from "../../../../const/URL.const";
import { ICallAPIFunction } from "../../../../yoello-lib/modules/API2/types";
import { IExtraGroup } from "../../../../interfaces/IExtraGroup";
import { useSnackbarMessages } from "../../../../yoello-lib/modules/components/snackbar/SnackbarContext";
import useCheckPermissions from "../../../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../../../const/permissions.const";
import DisabledActionWrapper from "../../../../yoello-lib/modules/components/DisabledActionWrapper";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      marginRight: "1rem",
      color: "#737FA4",
      backgroundColor: "transparent",

      "&:hover": {
        backgroundColor: "#F3F4F9",
      },
    },
    contentClassName: {
      whiteSpace: "nowrap",
      overflow: " hidden !important",
      textOverflow: "ellipsis",
      width: 0,
    },
  })
);

interface Props {
  menuItems: IMenuItemBody[];
  card: any;
  filterOptions: () => FilterOptionsType[];
  callExtraAPI: ICallAPIFunction<IExtraGroup>;
  searchMenuItems: ICallAPIFunction<IMenuItemBody[]>
}


const ExtraBulkAssign = (props: Props) => {
  const { card, menuItems, filterOptions, callExtraAPI, searchMenuItems } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const { goToNextStep } = useDialogRouteStages(history);
  const { sendSnackbarMessage } = useSnackbarMessages()!;
  const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);

  const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.MENU_MANAGEMENT);

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [selectedMenuItems, setSelectedMenuItems] = useState<IMenuItemBody[]>(
    []
  );

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getData() {
    setIsLoading(true);
    searchMenuItems(HTTPMethods.POST, {
      query: "?include_disabled=true",
      yoelloAPIParams: {
        size: 200,
      },
      isPaginated: true,
      body: {
        filters: [
          {
            child: "extras_groups",
            operator: "=",
            value: card.id,
          },
        ],
      },
    }).then((data) => {
      setSelectedMenuItems(data.data as IMenuItemBody[]);
      setIsLoading(false)
    });
  }
  const onSubmit = async (
    changed: ISearchableChecklistItem[]
  ) => {
    const body = [];
    /**check the selected items and if they are still in the list of changed
     * if not then we're removing them deleting any changed we already have
     */
    for (const items of selectedMenuItems) {
      const itemId = items.id;
      const indexOf = changed.findIndex((obj) => obj.id === itemId);
      if (indexOf > -1) {
        changed.splice(indexOf, 1);
      } else {
        body.push({
          menu_item_id: itemId,
          menu_items_extras_groups: { remove: [card.id] }
        })
      }
    }
    /**Checks the remaining changed items and appends them to the item */
    for (const items of changed) {
      const itemId = items.id;
      body.push({
        menu_item_id: itemId,
        menu_items_extras_groups: { append: [card.id] }
      })
    }
    await callExtraAPI(HTTPMethods.PATCH, {
      body
    });
    sendSnackbarMessage('snackbar.updateSuccess', 'success');
    getData();
  };

  const description = (
    <Trans
      i18nKey="menu.extras.description"
      count={card.name_public}
    >
      0<b>1</b>2
    </Trans>
  );

  const subtitle = (count: number) => (
    <Trans i18nKey="menu.extras.subtitle" count={count}>
      0<b>1</b>2
    </Trans>
  );

  const onClick = (event?: any) => {
    if (event) {
      event.stopPropagation();
    }
    if (!hasPermission) return;
    goToNextStep(
      dialogKeys.ASSIGNITEM,
      {
        ComponentProps: {
          description,
          subtitle,
          items: menuItems,
          selectedItems: selectedMenuItems,
          onSubmit,
          isVirtualizeList: true,
          filterOptions: filterOptions(),
          APIDefintion: APIDefintions.menusItems,
          subLabelKey: "name_internal",
          hasSubmitCancelButtons: true,
          hasToolbar: false
        },
        dialogTitle: t("menu.extras.dialogTitle"),
      },
      `${PRODUCTS_EXTRAS}/${card.id}${ADD_ITEM}`
    )
  };

  return isEposNow ? null : (
    <DisabledActionWrapper
      disabled={!hasPermission}
      onDisabledClick={onFailedInteraction}
    >
      <Button
        color="default"
        variant="contained"
        className={classes.button}
        onClick={onClick}
        disabled={menuItems.length === 0 || isLoading || !hasPermission}
      >
        {t("menu.extras.applyToItems")}
      </Button>
    </DisabledActionWrapper>

  );
};

export default ExtraBulkAssign;
